import { memo } from 'react';
import AssetSelector from './AssetSelector';
import AssetDetails from './AssetDetails';

export const AssetSelectorDetailsHeader = memo(() => {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(6, 1fr)',
        gap: '10px',
      }}
    >
      <div style={{ gridColumn: 'span 2' }}>
        <AssetSelector />
      </div>
      <div style={{ gridColumn: 'span 4' }}>
        <AssetDetails />
      </div>
    </div>
  );
});

AssetSelectorDetailsHeader.displayName = 'AssetSelectorDetailsHeader';

export default AssetSelectorDetailsHeader;
